'use client'

import React from 'react'
import Image from 'next/image'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { getDevicePlatform } from '@utils/segmentProperties'
import { CONTACT_US_EVENTS, CONTACT_US_CTA_MAPPING } from '@configs/contactus.config'
import { RIGHT_ARROW_URL } from '@constants/contactUs.constants'
import styles from './BotCard.module.scss'

const FaqButton = ({ btn, handleClick }) => {
  const { url, alternativeText } = btn?.icon?.data?.attributes || {}
  const handleFaqClick = async () => {
    await trackEvent(CONTACT_US_EVENTS.TAP_CTA.eventName, {
      ...CONTACT_US_EVENTS.TAP_CTA.eventProps,
      platform: getDevicePlatform(),
      cta_text: CONTACT_US_CTA_MAPPING[btn.text],
    })

    handleClick(btn.text)
  }
  return (
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    <button type="button" key={btn.id} className={styles.faqButton} onClick={handleFaqClick}>
      <div className={styles.iconContainer}>
        {url && <Image src={url} height={24} width={24} alt={alternativeText || 'faq-icon'} />}
        <span>{btn.text}</span>
      </div>
      <div>
        <Image src={RIGHT_ARROW_URL} alt="right-arrow" width={24} height={24} />
      </div>
    </button>
  )
}

export default FaqButton
